import useAdminFeedbackCycles from '~src/hooks/api/adminFeedback/useAdminFeedbackCycles';
import { FeedbackMeetingCyclesContainer } from './FeedbackMeetingCycles.styled';
import FeedbackCycleItem from './FeedbackCycleItem/FeedbackCycleItem';
import LoadingSpinner from '~src/shared/loadingSpinner/LoadingSpinner';
import { MainContainerAnimation } from '~src/styles/animations';

const FeedbackMeetingCycles = () => {
  const { data, isLoading } = useAdminFeedbackCycles();

  if (isLoading) {
    return (
      <FeedbackMeetingCyclesContainer>
        <LoadingSpinner />
      </FeedbackMeetingCyclesContainer>
    );
  }

  return (
    <MainContainerAnimation>
      <FeedbackMeetingCyclesContainer>
        {data?.map((item) => {
          return <FeedbackCycleItem key={item.id} {...item} />;
        })}
      </FeedbackMeetingCyclesContainer>
    </MainContainerAnimation>
  );
};

export default FeedbackMeetingCycles;
